module.exports = __webpack_public_path__ + "static/icon__iterative--multicolor-2832eb7a43d1d9a0bdf5ba0f577c14df.png";